import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import PercentIcon from "@mui/icons-material/Percent";
import ShieldIcon from "@mui/icons-material/Shield";
import { keyframes } from "@emotion/react";
import withyou from "../../Assests/withyou.png"
import geteway1 from "../../Assests/geteway1.png"
import geteway2 from "../../Assests/geteway2.png"
import geteway3 from "../../Assests/geteway3.png"
import geteway4 from "../../Assests/geteway4.png"


const features = [
  {
    icon: <img src={geteway1} alt="" width={60} height={60} style={{ display: 'block' }} />,
    title: "Seamless Payments",
    highlight: "Integration",
    description:
      "Easily connect Zutopay to your website or app — no tech headaches, just smooth transactions from day one.",
  },
  {
    icon: <img src={geteway2} alt="" width={60} height={60} style={{ display: 'block' }} />,
    title: "Transparent 1.4%",
    highlight: "Charges",
    description:
      "Flat, fair, and easy to understand. Keep your profits strong with one of the lowest transaction fees in the market.",
  },
  {
    icon: <img src={geteway3} alt="" width={60} height={60} style={{ display: 'block' }} />,
    title: "Fast & Secure",
    highlight: "Settlements",
    description:
      "Experience instant or next-day payouts with top-level security that protects every transaction.",
  },
  {
    icon: <img src={geteway4} alt="" width={60} height={60} style={{ display: 'block' }} />,
    title: "24/7",
    highlight: "Support",
    description:
      "Round-the-clock customer support to assist you with any queries or issues you might have.",
  },
 
];

const ZutopayFeatures = () => {
  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 5 },
        py: { xs: 6, md: 10 },
        backgroundColor: "#fafafa",
      }}
    >
      {/* Heading */}
     <Typography
    variant="h5"
    fontWeight={510}
    sx={{
        fontSize: { xs: "28px", sm: "34px", md: "46px" },
        textAlign: { xs: "center", md: "left" },
        fontWeight: 500,
        lineHeight: 1,
    }}
>
    Start with Zutopay the payment <br className="hideOnMobile" /> gateway
    that grows{" "}
    <Typography
        component="span"
        sx={{ 
            color: "#0066FF", 
            fontStyle: "italic"
        }}
    >
        {/*
          CORRECTED SECTION:
          - Removed mt property.
          - Added 'transform: translateY(4px)' to shift the image 4 pixels down.
          - Increased the negative margin on the top (-15px) to pull the surrounding Typography back up,
            since the image's height is still part of the span's dimensions.
        */}
        <Box 
            component="span" 
            sx={{ 
                display: 'inline-block', 
                transform: 'translateY(4px)', // Shifts the image 4px down visually
                // Use negative margin to offset the space the inline-block element occupies
                mb: -1.5, 
                mt: -1.5, 
            }}
        >
            <img src={withyou} alt="" width={120} height={80} style={{ display: 'block' }} />
        </Box>
    </Typography>
    {/* Assuming the word "with" was meant to be here, based on previous context. */}
</Typography>

      {/* Subtext */}
      <Typography
        sx={{
          mt: 1,
          mb: 4,
          color: "#6b6b6b",
          textAlign: { xs: "center", md: "left" },
          fontSize: { xs: "14px", sm: "15px" },
        }}
      >
        Empowering startups and enterprises with seamless payments, instant
        settlements, and transparent pricing.
      </Typography>

      {/* Animated Feature Cards */}
      <Box
        sx={{
          width: "100%",
          py: 2,
          overflowX: "hidden",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "fit-content",
            animation: `${keyframes`
              0% { transform: translateX(0); }
              100% { transform: translateX(calc(-320px * ${features.length / 2})); }
            `} ${features.length * 5}s linear infinite`,
            "&:hover": {
              animationPlayState: "paused",
            },
            "@media (max-width:600px)": {
              animation: "none",
              overflowX: "auto",
              scrollSnapType: "x mandatory",
            },
          }}
        >
          {[...features, ...features].map((f, index) => (
            <Box
              key={index}

              sx={{
                width: { xs: 280, sm: 320, md: 400 },
                flexShrink: 0,
                px: 1,
                boxShadow: "none",
                scrollSnapAlign: "start",
              }}
            >
              <Card
                sx={{
                  p: { xs: 2, sm: 2.5 },
                  borderRadius: 3,
                  textAlign: "left",
                  boxShadow: "none",
                  height: { xs: "auto", md: "240px" },
                  minHeight: { xs: "220px", md: "240px" },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                 
                }}
              >
                <CardContent>
                  {f.icon}
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    sx={{ mt: 2, fontSize: { xs: "17px", sm: "18px" } }}
                  >
                    {f.title}{" "}
                    <Typography
                      component="span"
                      sx={{ 
                        color: "#0066FF", 
                        fontSize: { xs: "17px", sm: "18px" },
                        fontStyle: "italic",
                        fontFamily: "'Ibarra Real Nova', serif",
                        fontWeight: 600
                      }}
                    >
                      {f.highlight}
                    </Typography>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 1.5,
                      color: "#6b6b6b",
                      fontSize: { xs: "13px", sm: "14px" },
                    }}
                  >
                    {f.description}
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ZutopayFeatures;
